export default __webpack_public_path__ + "static/media/instagram.c7d7cefd.svg";